import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, ActivatedRoute } from '@angular/router'; // Add ActivatedRoute
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { VacationSwitchComponent } from 'src/app/shared/components/vacations/vacation-switch/vacation-switch.component';
import { OperationalCardComponent } from 'src/app/shared/components/vacations/operational-card/operational-card.component';
import { HolidaysService } from 'src/app/shared/services/holidays/holidays.service';
import {
  ExerciseResponse,
  OperativeResponse,
} from 'src/app/shared/interfaces/holidays.interface';

@Component({
  selector: 'app-exercise',
  imports: [
    LoaderComponent,
    MatIconModule,
    RouterLink,
    MatButtonModule,
    MatSlideToggleModule,
    MatTabGroup,
    MatTab,
    OperationalCardComponent,
    VacationSwitchComponent,
    RouterLink,
  ],
  templateUrl: './exercise.component.html',
  styleUrls: ['./exercise.component.css', '../../../shared/styles/layout.css'],
})
export class ExerciseComponent implements OnInit {
  public exercise?: ExerciseResponse;
  public data: OperativeResponse[] = [];

  constructor(
    private loaderService: LoaderService,
    private holidaysService: HolidaysService,
    private route: ActivatedRoute // Inject ActivatedRoute
  ) {
    // Remove the navigation state logic from constructor
  }

  ngOnInit(): void {
    this.loaderService.showLoader();
    // Get the exercise ID from route params and fetch data
    const exerciseId = this.route.snapshot.params['id'];
    const year = this.route.snapshot.params['year'];
    if (exerciseId) {
      this.getExercise(exerciseId);
      this.getOperatives(exerciseId);
    }
  }

  getExercise(id: number) {
    this.holidaysService.getExerciseById(id, false).subscribe((exercise) => {
      this.exercise = exercise;
    });
  }

  getOperatives(id: number) {
    this.holidaysService.getExerciseOperatives(id).subscribe({
      next: (response) => {
        // Filter and map operative assignments to show only active operatives
        this.data = response.operativa_assignments
          .filter(
            (assignment) =>
              assignment.status === 'active' &&
              !assignment.is_deleted &&
              assignment.operativa_details.active &&
              !assignment.operativa_details.is_deleted
          )
          .map(
            (assignment) => assignment.operativa_details as OperativeResponse
          );

        this.loaderService.hideLoader();
      },
      error: (err) => {
        console.error('Error fetching operatives', err);
        this.loaderService.hideLoader();
      },
    });
  }

  get isLoading(): boolean {
    return this.loaderService.getLoader();
  }
}
